import { useEffect, useState } from "react";
import { Container, List, Text, Stepper, Button, Group } from "@mantine/core";
import { Alert, Dropdown, message } from "antd";
import Companyprofiles from "./Forms/Companyprofiles";
import Complienceform from "./Forms/Complienceform";
import Bankdetailsform from "./Forms/Bankdetailsform";
import { useAuthContext } from "../Hooks/UseAuthContext";
import { IconUserCircle } from "@tabler/icons-react";
import Merchantduedeligence from "./Forms/Merchantduedeligence";
import Boardofresolutionform from "./Forms/Board_of_resolutionform";
import Merchantcriminalundertaking from "./Forms/Merchantcriminalundertaking";
// import Payoutcommercial from "./Commercials/Payoutcommercial";
import Uploaddocs from "./Forms/Uploadocs";
import Termsandconditions from "./Forms/Termsandconditions";
import Submission from "../Components/Submission";










const Home = () => {
    const { user, dispatch } = useAuthContext();
    const [active, setActive] = useState(0);
    const [Userprofile, setUserprofile] = useState(null);
    const [loading, setLoading] = useState(true);
    const nextStep = () => setActive((current) => (current < 10 ? current + 1 : current));
    const prevStep = () => setActive((current) => (current > 0 ? current - 1 : current));

    const Logout = () => {
        message.loading('Logging out...', 1.5).then(() => {
            message.success('Logged out successfully');
            dispatch({ type: 'LOGOUT' });
            localStorage.removeItem('user');
            localStorage.removeItem('expiryTime');
            //window.location.reload();
            window.location.href = '/'; // Redirect to login page after logout
        })
    }

    useEffect(() => {
        const getUserData = async () => {
            const response = await fetch('https://api.boompay.in/get-user', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data);
                setUserprofile(data.user);
                setActive(data.user.Completed_step);
                setLoading(false);
            } else if (response.status === 401) {
                setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setLoading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setLoading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user) {
            getUserData();
        }

    }, [user])
    
    return (
        <>

            <Alert title={<Text size="sm" fw={'bold'}> Welcome to BOOM PAY TECHNOLOGY PVT. LTD. ONBOARD TO OUR PLATFORM: </Text>} type="success" style={{ margin: '3px' }}
                description={
                    <>
                        <List>
                            <List.Item><Text size="xs" c={'dimmed'}>Here you can onboard your business and submit onbaording documents.</Text></List.Item>
                            <List.Item><Text size="xs" c={'dimmed'}>You can also check the status of your onboarding process and track the progress.</Text></List.Item>
                            <List.Item><Text size="xs" c={'dimmed'}>If you did not submit the required documents and details, so automatic rejection will be done by the system after 7 days of onboarding.</Text></List.Item>
                            <List.Item><Text size="xs" c={'dimmed'}>For any query contact to our team. info@boompay.in</Text></List.Item>
                        </List>




                    </>

                } action={<>
                    <Group justify="end" m="sm">
                        <Dropdown
                            menu={{
                                items: [
                                    {
                                        key: '0',
                                        label: <Text size="xs" c={'dimmed'}>Profile ID: {Userprofile?._id}</Text>,
                                    },
                                    {
                                        key: '1',
                                        label: <Text size="xs" c={'dimmed'}>Company Name: {Userprofile?.Company_Name}</Text>,
                                    },
                                    {
                                        key: '2',
                                        label: <Text size="xs" c={'dimmed'}>Company Email: {Userprofile?.Company_Email}</Text>,
                                    },
                                    {
                                        key: '3',
                                        label: <Text size="xs" c={'dimmed'}>Created at: {Userprofile?.createdAt}</Text>,
                                    },
                                    {
                                        key: '4',
                                        label: <Text size="xs" c={Userprofile?.Account_Status === 'Active' ? 'green' : 'red'}>Account Status: {Userprofile?.Account_Status}</Text>,
                                    },
                                    {
                                        key: '5',
                                        label: <Button variant="transparent" color="red" fullWidth onClick={Logout}>Logout</Button>,
                                    },
                                ],
                            }}
                            trigger={['click']}
                        >
                            <Button
                                variant="light"
                                color="blue"
                                radius="xs"
                                size="xs"
                                loading={loading}
                                leftSection={<IconUserCircle stroke={1.2} size={20} />}
                            >
                                Welcome back, {Userprofile?.Company_Name}
                            </Button>
                        </Dropdown>
                    </Group>
                </>} />
            <Container size={'lg'} mt={'md'} p={'sm'}>
                <Group justify="end" mb="xl">
                    {active > 0 && <Button variant="default" onClick={prevStep}>Back</Button>}
                    {active < 9 && <Button onClick={nextStep} radius={'xs'} color="orange" variant="filled" size="sm">Next step</Button>}

                </Group>
                <Stepper active={active} onStepClick={setActive} size="xs" allowNextStepsSelect={false}>
                    <Stepper.Step label="First step" description="Fill your comapny and service details">
                        <Companyprofiles />
                    </Stepper.Step>
                    <Stepper.Step label="Second step" description="Complience details & MAF">
                        <Complienceform />
                    </Stepper.Step>
                    <Stepper.Step label="Third step" description="Bank details">
                        <Bankdetailsform />
                    </Stepper.Step>
                    <Stepper.Step label="Fourth step" description="Merchant Due Diligence">
                        <Merchantduedeligence />
                    </Stepper.Step>
                    <Stepper.Step label="Fifth step" description="Board of resolution">
                        <Boardofresolutionform />
                    </Stepper.Step>
                    <Stepper.Step label="Sixth step" description="Merchant criminal undertaking">
                        <Merchantcriminalundertaking />
                    </Stepper.Step>
                    {/* <Stepper.Step label="Seventh step" description="Payout Commercial Offer Letter">
                        <Payoutcommercial />
                    </Stepper.Step> */}
                    <Stepper.Step label="Eight step" description="Upload documents">
                        <Uploaddocs />
                    </Stepper.Step>
                    <Stepper.Step label="Ninth step" description="Terms & Conditions">
                        <Termsandconditions />
                    </Stepper.Step>
                    <Stepper.Completed>
                        <Submission />
                    </Stepper.Completed>
                </Stepper>
            </Container>


        </>
    )
}
export default Home; 